import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Webvisibility() {
  return (
    <section className="web_visibility p-100">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center resp_order"
          >
            <StaticImage
              src="../../images/services-usa/search-engine/dominate_search.webp"
              alt="TekRevol"
              layout="constrained"
              className="search_engine_second_fold"
              placeholder="blurred"
              formats={["webp"]}
              width={549}
              height={655}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>Dominate Search Results & Accelerate Business Growth</h2>
            <p>
              In modern, evolving digital marketplaces, leveraging Search Engine
              Marketing (SEM) is critical to gain a competitive edge. Our
              data-driven search engine marketing services ensure your ads
              appear precisely when high-intent users search for relevant
              products and services. This precision targeting minimizes wasted
              ad spend and maximizes return on investment (ROI).
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Webvisibility;
